import { render, staticRenderFns } from "./WriteOffMovementCurrencyInput.vue?vue&type=template&id=6b0f0fe4&scoped=true"
import script from "./WriteOffMovementCurrencyInput.vue?vue&type=script&lang=ts"
export * from "./WriteOffMovementCurrencyInput.vue?vue&type=script&lang=ts"
import style0 from "./WriteOffMovementCurrencyInput.vue?vue&type=style&index=0&id=6b0f0fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f0fe4",
  null
  
)

export default component.exports